/*
These functions make sure WordPress
and Foundation play nice together.
*/
jQuery(document).ready(function() {

	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
	});


	//Video Play Rezeptslider
	if(jQuery('.rezeptslider').length != 0) {
		jQuery('.slick-active .rezept video').get(0).play();

		jQuery('.rezept video').mouseenter(function () {
			var inhover = jQuery(this)
			jQuery('.rezept video').each(function (that) {
				jQuery(this).get(0).pause();
			});
			inhover.get(0).play();
		}).mouseleave(function () {
			jQuery(this).get(0).pause();
			jQuery('.slick-active .rezept video').get(0).play();
		})

		jQuery('.rezeptslider').on('afterChange', function (event, slick, direction) {
			jQuery('.rezept video').each(function () {
				jQuery(this).get(0).pause();
			});
			if(jQuery('.slick-active .rezept video').length != 0){
				jQuery('.slick-active .rezept video').get(0).play();
			}
		});
	}

	var hdreiheight = 0;

	var frames = document.getElementsByTagName('iframe');
	for (var frame of frames) {
		frame.setAttribute("sandbox", "allow-scripts allow-same-origin");
	}


	// Search field
	jQuery('.searchopen').on( 'click', function() {
		if(jQuery( ".searchinner" ).hasClass('active')){
			jQuery( ".searchinner" ).removeClass('active');
			jQuery('.searchopen').removeClass('active');
		}else{
			jQuery( ".searchinner" ).addClass('active');
			jQuery('.searchopen').addClass('active');
			jQuery("input.search-field").focus();
		}
	});

	jQuery(".hamburger, .js-off-canvas-overlay").click(function() {
		jQuery('.hamburger').toggleClass("is-active");
	});
	jQuery(".open, .close").click(function() {
		jQuery(this).closest('.zitattext').toggleClass("active");
	});

	jQuery('.feathervideo').click(function() {
		setTimeout(function(){jQuery('.featherlight-iframe .lbvideo iframe').attr('src' , jQuery('.featherlight-iframe .lbvideo iframe').attr('src') + "&autoplay=1");}, 1000);
	});  

	var has_fired = false;
	jQuery(window).scroll(function() {

	});

	jQuery('a').click(function (event){
		var element= jQuery(this).attr("href");
		var target= jQuery(this).attr("target");
		var feath= jQuery(this).attr("data-featherlight");
		if(element.indexOf("#") > -1) {

		}
		else if(jQuery(this).hasClass('emaillink')){

		}
		else if(target=="_self" || target=="_blank"){

		}
		else if(feath=="ajax" || feath!="" ){
			jQuery('.pdfjs-fullscreen a').attr("target","_blank");
		}
		else if(element=="#"){

		}
		else{
			event.preventDefault();
			jQuery('body').animate({
				function() {
					location.href = element;
					jQuery('#preloader').slideDown(200,'swing'); // will fade out the white DIV that covers the website.
					jQuery('#status	').delay( 200 ).fadeIn(1200);
					location.href = element;
				}    
			});
		}
	});

	jQuery(".scrolldown svg").click(function(){
			jQuery('html, body').animate({
				scrollTop: window.pageYOffset + (jQuery(window).height()-45)+'px'
			}, 800);
	});

	if(jQuery('.produktvielfalt').length != 0){
		var zeile1 = jQuery('.zeile1').position().left;
		var zeile1w = jQuery('.zeile1')[0].scrollWidth;
		var zeile2 = jQuery('.zeile2').position().left;
		var zeile2w = jQuery('.zeile2')[0].scrollWidth;
		var zeile3 = jQuery('.zeile3').position().left;
		var zeile3w = jQuery('.zeile3')[0].scrollWidth;
		var zeile4 = jQuery('.zeile4').position().left;
		var zeile4w = jQuery('.zeile4')[0].scrollWidth;
		var height = jQuery(window).scrollTop();
		var winwidth = jQuery(window).width() - 120;
		var winheight = jQuery(window).height();
		var offset1 = (winwidth - zeile1w) / 75;
		var offset2 = (winwidth - zeile2w) / 75;
		var offset3 = (winwidth - zeile3w) / 75;
		var offset4 = (winwidth - zeile4w) / 75;
		var offtop = jQuery('.produktvielfalt').offset().top;
		jQuery(".zeile1").css('left', winwidth - zeile1w);
		jQuery(".zeile3").css('left', winwidth - zeile3w);
		$sfpos = jQuery(window).scrollTop();
		//scroll menue einblendung
		jQuery(window).scroll(function() {
			var zeile1 = jQuery('.zeile1').position().left;
			var zeile2 = jQuery('.zeile2').position().left;
			var zeile3 = jQuery('.zeile3').position().left;
			var zeile4 = jQuery('.zeile4').position().left;


			if((jQuery(window).scrollTop() > (offtop - winheight) && jQuery(window).scrollTop() < (offtop - winheight) + winheight)){
				if(jQuery(window).scrollTop() > $sfpos ){
					jQuery(".zeile1").css('left', zeile1 - offset1);
					jQuery(".zeile2").css('left', zeile2 + offset2);
					jQuery(".zeile3").css('left', zeile3 - offset3);
					jQuery(".zeile4").css('left', zeile4 + offset4);
				}else{
					jQuery(".zeile1").css('left', zeile1 + offset1);
					jQuery(".zeile2").css('left', zeile2 - offset2);
					jQuery(".zeile3").css('left', zeile3 + offset3);
					jQuery(".zeile4").css('left', zeile4 - offset4);
				}
			}
			$sfpos = jQuery(window).scrollTop();
		});
	}



});





function unten() {
	jQuery('.scrolldown svg').css({'transform' : 'rotate('+ 0 +'deg)'});
}

function oben() {
	jQuery('.scrolldown svg').css({'transform' : 'rotate('+ 180 +'deg)'});
}

function rotate($el, degrees) {
	$el.css({
		'-webkit-transform' : 'rotate('+degrees+'deg)',
		'-moz-transform' : 'rotate('+degrees+'deg)',
		'-ms-transform' : 'rotate('+degrees+'deg)',
		'-o-transform' : 'rotate('+degrees+'deg)',
		'transform' : 'rotate('+degrees+'deg)',
		'zoom' : 1
	});
}
jQuery(window).on('resize', function(){

});

jQuery(window).on('pageshow',function(){
	jQuery('#preloader').delay( 50 ).slideUp(600); // will fade out the white DIV that covers the website.
	jQuery('#status	').fadeOut(150);
}); //code here });